// extracted by mini-css-extract-plugin
module.exports = {"headerSize":"100px","smallScreen":"1220px","mediumScreen":"1440px","tabletScreen":"992px","mobileScreen":"664px","gray":"#eee","mainColor":"#49B748"};